export const RecipientConst = {
   RECIPIENT_TYPE: {
      STUDENTS: 1,
      PARENTS: 2,
      STAFF: 3,
      VENDORS: 4,
      CCA_GROUPS: 5,
      PROPOSAL_FORM: 6,
   },

   // Must match the types above
   RECIPIENT_CATEGORY: [
      { id: 1, text: "Students" },
      { id: 2, text: "Parents" },
      { id: 3, text: "Staff" },
      { id: 4, text: "Vendors" },
      { id: 5, text: "CCA Group" },
   ],

   RECIPIENT_CODE: {
      ALL_STUDENTS: 100,
      STUDENTS_YEAR_01: 101,
      STUDENTS_YEAR_02: 102,
      STUDENTS_YEAR_03: 103,
      STUDENTS_YEAR_04: 104,
      STUDENTS_YEAR_05: 105,
      STUDENTS_YEAR_06: 106,
      STUDENTS_YEAR_07: 107,
      STUDENTS_YEAR_08: 108,
      STUDENTS_YEAR_09: 109,
      STUDENTS_YEAR_10: 110,
      STUDENTS_YEAR_11: 111,
      STUDENTS_YEAR_12: 112,
      STUDENTS_YEAR_13: 113,
      ALL_PARENTS: 115,
      ALL_STAFF: 116,
      ALL_VENDORS: 117,
      ALL_CCA_GROUPS: 118,
      INDIVIDUAL_STUDENT: 120,
      INDIVIDUAL_PARENT: 121,
      INDIVIDUAL_STAFF: 122,
      INDIVIDUAL_VENDOR: 123,
      INDIVIDUAL_CCA_GROUP: 124,
      INDIVIDUAL_CCA_GROUP_ADMIN: 125,
   },

   // Must match the above codes
   RECIPIENT_GROUP: [
      { id: 100, type: 1, text: "All Students", color: "red lighten-1" },
      { id: 101, type: 1, text: "Year 1", color: "teal lighten-1" },
      { id: 102, type: 1, text: "Year 2", color: "teal lighten-1" },
      { id: 103, type: 1, text: "Year 3", color: "teal lighten-1" },
      { id: 104, type: 1, text: "Year 4", color: "teal lighten-1" },
      { id: 105, type: 1, text: "Year 5", color: "teal lighten-1" },
      { id: 106, type: 1, text: "Year 6", color: "teal lighten-1" },
      { id: 107, type: 1, text: "Year 7", color: "teal lighten-1" },
      { id: 108, type: 1, text: "Year 8", color: "teal lighten-1" },
      { id: 109, type: 1, text: "Year 9", color: "teal lighten-1" },
      { id: 110, type: 1, text: "Year 10", color: "teal lighten-1" },
      { id: 111, type: 1, text: "Year 11", color: "teal lighten-1" },
      { id: 112, type: 1, text: "Year 12", color: "teal lighten-1" },
      { id: 113, type: 1, text: "Year 13", color: "teal lighten-1" },
      { id: 115, type: 2, text: "All Parents", color: "red lighten-1" },

      { id: 116, type: 3, text: "All Staff", color: "red lighten-1" },
      { id: 117, type: 4, text: "All Vendors", color: "red lighten-1" },
      { id: 118, type: 5, text: "All CCA Groups", color: "red lighten-1" },

      {
         id: 120,
         type: 1,
         text: "Individual Student",
         color: "primary",
      },
      {
         id: 121,
         type: 2,
         text: "Individual Parent",
         color: "primary",
      },
      {
         id: 122,
         type: 3,
         text: "Individual Staff",
         color: "primary",
      },
      {
         id: 123,
         type: 4,
         text: "Individual Vendor",
         color: "primary",
      },
      {
         id: 124,
         type: 5,
         text: "Individual CCA Group",
         color: "primary",
      },
      {
         id: 125,
         type: 5,
         text: "Individual CCA Group Admin",
         color: "orange",
      },
   ],

   YEAR_GROUP: [
      { year: "1", code: 101 },
      { year: "2", code: 102 },
      { year: "3", code: 103 },
      { year: "4", code: 104 },
      { year: "5", code: 105 },
      { year: "6", code: 106 },
      { year: "7", code: 107 },
      { year: "8", code: 108 },
      { year: "9", code: 109 },
      { year: "10", code: 110 },
      { year: "11", code: 111 },
      { year: "12", code: 112 },
      { year: "13", code: 113 },
   ],
};
